import { CreateActionParams } from '../actions';
import { ServiceData } from '../../../../utils/state/types';
import { PaymentOption } from '../../../../types/types';
import { SelectedPaymentOption } from '../../../../types/ambassador/bookings/ambassador-bookings-v2-booking';

export type SetDefaultPaymentOptions = (dataToUpdate: {
  [key: string]: {
    selectedPaymentOption: PaymentOption;
    selectedPaymentType: SelectedPaymentOption;
  };
}) => void;

export function createSetDefaultPaymentOptionsAction({
  getControllerState,
}: CreateActionParams): SetDefaultPaymentOptions {
  return async (dataToUpdate: {
    [key: string]: {
      selectedPaymentOption: PaymentOption;
      selectedPaymentType: SelectedPaymentOption;
    };
  }) => {
    const [state, setState] = getControllerState();
    const updatedServiceData: ServiceData = { ...state.serviceData };

    Object.keys(dataToUpdate).forEach((serviceIdentifier) => {
      const { selectedPaymentOption, selectedPaymentType } =
        dataToUpdate[serviceIdentifier];

      updatedServiceData.slotServices[serviceIdentifier] = {
        ...updatedServiceData.slotServices[serviceIdentifier],
        selectedPaymentOption,
        selectedPaymentType,
      };
    });

    setState({ serviceData: updatedServiceData });
  };
}
